"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getAllPathNodes_1 = __importDefault(require("./getAllPathNodes"));
const hasPaths = (nodes) => getAllPathNodes_1.default(nodes).length > 0;
exports.default = hasPaths;
